import { DESTINATION, DESTINATION_TYPE } from '@adtrackify/at-tracking-event-types';

import { usePixelDestinations } from '@/hooks/account/use-pixel-destinations';

interface DestinationStatus {
  isMetaConnected: boolean;
  isGoogleConnected: boolean;
  isTiktokConnected: boolean;
  isKlaviyoConnected: boolean;
  anyConnected: boolean;
  connectedCount: number;
}

export function useDestinationStatus(): DestinationStatus {
  const destinations = usePixelDestinations();

  const isMetaConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.FACEBOOK &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  const isGoogleConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.GOOGLE_ADS &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  const isTiktokConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.TIKTOK &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  const isKlaviyoConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.KLAVIYO &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  const connectedCount = [isMetaConnected, isGoogleConnected, isTiktokConnected, isKlaviyoConnected].filter(Boolean).length;
  const anyConnected = connectedCount > 0;

  return {
    isMetaConnected,
    isGoogleConnected,
    isTiktokConnected,
    isKlaviyoConnected,
    anyConnected,
    connectedCount,
  };
}

export function checkDestinationConnections(destinations: Array<{ destination?: string; destinationType?: string; enabled?: boolean } | undefined>) {
  const isMetaConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.FACEBOOK &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  const isGoogleConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.GOOGLE_ADS &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  const isTiktokConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.TIKTOK &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  const isKlaviyoConnected = destinations.some(
    (d) =>
      d?.destination === DESTINATION.KLAVIYO &&
      d?.destinationType === DESTINATION_TYPE.DESTINATION &&
      d?.enabled
  );

  return {
    isMetaConnected,
    isGoogleConnected,
    isTiktokConnected,
    isKlaviyoConnected,
    anyConnected: isMetaConnected || isGoogleConnected || isTiktokConnected || isKlaviyoConnected,
  };
}
